import axios, { AxiosResponse } from 'axios';
import { AssessmentType } from '../AssessmentPrinting/AssessmentPrintingList';

/**
 * @description 評估單物件
 * @property {number} id - 評估單ID
 * @property {string} name - 評估單名稱
 */
export interface TAssessmentForm {
    id: number;
    name: string;
    assessmentNames: string[];
    type: AssessmentType;
}

/**
 * @description API 回應物件
 * @property {Array} data - 包含ID和名稱的資料陣列
 */
export interface TResponse {
    data: TAssessmentForm[];
}

/**
 * 取得綜合評估服務管理 - 評估單
 * @returns {Promise<AxiosResponse<TResponse>>} - 回應物件
 */
async function apiComprehensiveAssessmentServiceManagementForms() {
    const response: AxiosResponse<TResponse> = await axios.request({
        url: '/api/comprehensive-assessment-service-management/forms',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response;
}

export { apiComprehensiveAssessmentServiceManagementForms };
